export default function replaceObjectInArray(array1, array2, uniqueKey) {
	return array1.map(
		(obj) => array2.find((o) => o[uniqueKey] === obj[uniqueKey]) || obj
	);
}
